import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import { backendURL } from "../../../config/constants";
import { MdOutlineLockReset } from "react-icons/md";
import { ROUTES } from "../../../routes/routes";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [popup, setPopup] = useState({ show: false, type: "", message: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    setMessage("");
    setPopup({ show: false, type: "", message: "" });

    try {
      const response = await fetch(`${backendURL}/users/forget-password/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to send reset email");
      }

      setPopup({
        show: true,
        type: "success",
        message: data.message || "Password reset email sent successfully",
      });
      setEmail("");
      setTimeout(() => {
        navigate(ROUTES.resetPassword.path);
      }, 10000);
    } catch (err) {
      console.error(err);
      setPopup({
        show: true,
        type: "error",
        message: err.message || "Something went wrong. Please try again.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (popup.show) {
      const timer = setTimeout(() => {
        setPopup({ show: false, type: "", message: "" });
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [popup]);

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
          <div className="shape shape-5"></div>
        </div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="logo">
            <div className="logo-icon">
              <MdOutlineLockReset />
            </div>
            <h1 className="logo-text">Reset Password</h1>
          </div>
          <p className="login-subtitle">
            Enter your email address and we’ll send you instructions to reset
            your password.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <div className="input-wrapper">
              <span className="input-icon">📧</span>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                placeholder="Enter your registered email"
                required
                disabled={isLoading}
              />
            </div>
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">⚠️</span> {error}
            </div>
          )}

          {message && (
            <div className="success-message">
              <span className="success-msg-icon">✅</span> {message}
            </div>
          )}

          <button
            type="submit"
            className={`login-submit-btn ${isLoading ? "loading" : ""}`}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="loading-spinner"></span> Sending...
              </>
            ) : (
              <>
                <span className="auth-icon">📨</span> Send Reset Link
              </>
            )}
          </button>
        </form>

        <div className="login-toggle">
          <p className="toggle-text">
            Remembered your password?{" "}
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="toggle-btn"
              disabled={isLoading}
            >
              Sign In
            </button>
          </p>
        </div>
      </div>
      {/* ✅ Center Popup */}
      {popup.show && (
        <div className="popup-overlay">
          <div
            className={`popup-center-box ${
              popup.type === "success" ? "popup-success" : "popup-error"
            }`}
          >
            <p>{popup.message}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
